import { useState, useEffect, useMemo, } from 'react'
import Sanitized from './Sanitized'
import MoreButton from '@components/display/MoreButton'
import strip from '@utils/html/strip'
import excerpt from '@utils/string/excerptMaintainingWords'
import useWindowWidth from '@hooks/useWindowWidth'

export default function ({ html = '', maxChars = 500 }) {
    if (!html) return null

    const [onMobile, setOnMobile] = useState(false) // we want to display all text on default for Google
    const [showAll, setShowAll] = useState(false)
    const width = useWindowWidth()

    useEffect(() => {
        if (width <= 800 && !onMobile) {
            setOnMobile(true)

        } else if (width > 800 && onMobile) {
            setOnMobile(false)
        }
    }, [width])

    const textShouldBeSplit = Boolean(onMobile && html.length > maxChars)
    const showToggleButton = Boolean(textShouldBeSplit)

    const toggleShow = () => setShowAll(!showAll)

    const showFullText = textShouldBeSplit && !showAll
    const memoKey = `${showFullText}${html.length}${html.slice(0, 3)}`

    const textToShow = useMemo(() => showFullText
        ? excerpt(strip(html), maxChars, '')
        : html, [memoKey])

    return <>
        <Sanitized html={textToShow} />
        { showToggleButton &&
            <MoreButton onClick={toggleShow} shown={showAll} /> }
    </>
}